import { DocumentSearchPanel } from "@/components/panels/DocumentSearchPanel"
import { DOCUMENT_FACETS as facets } from "@/constants/facets"
import { DocumentSearchProvider } from "@/plugins/providers/document/DocumentSearchProvider"
import { useUserSession } from "@session/UserSession"

export function SearchPage() {
    const { project } = useUserSession()

    return (
        <DocumentSearchProvider facets={facets(project?.id || "")}>
            <DocumentSearchPanel />
        </DocumentSearchProvider>
    )
}